import cx from 'classnames';
import React from 'react';
import styles from './OMFiltersTitle.scss';

const OMFiltersTitle = properties => (
  <div className={cx(styles.wrapper, properties.className, { [styles.mobile]: properties.isMobile })}>
    <span className={styles.iconWrapper}><i className={`icon icon-${properties.icon}`} /></span>
    <span className={styles.label}>{properties.label}</span>
  </div>
);

export default OMFiltersTitle;
